import React from 'react';
import { SelectMenu } from '@scale/scaleui';
import { ModelInputFileAttachmentType } from '@scale/shared/types/chat';

interface ModelInputFileAttachmentChoicesBuilderProps {
  name: string;
  existingValue?: ModelInputFileAttachmentType;
  updateProperty: (arg: ModelInputFileAttachmentType) => void;
  required?: boolean;
}

interface AttachmentOption {
  id: ModelInputFileAttachmentType;
  name: string;
}

const attachmentOptions: Array<AttachmentOption> = [
  { id: ModelInputFileAttachmentType.Image, name: ModelInputFileAttachmentType.Image },
  { id: ModelInputFileAttachmentType.Text, name: ModelInputFileAttachmentType.Text },
  { id: ModelInputFileAttachmentType.Json, name: ModelInputFileAttachmentType.Json },
  { id: ModelInputFileAttachmentType.Audio, name: ModelInputFileAttachmentType.Audio },
];

const ModelInputFileAttachmentChoicesBuilder: React.FC<
  ModelInputFileAttachmentChoicesBuilderProps
> = ({ name, existingValue, updateProperty, required }) => {
  return (
    <div className="flex flex-col items-start">
      <div className="flex items-center">
        {name && <div className="my-1 text-sm font-medium leading-6 text-neutral-700">{name}</div>}
      </div>
      <SelectMenu
        className="w-36"
        options={attachmentOptions}
        selectedOptionId={existingValue ?? ModelInputFileAttachmentType.Image}
        setSelected={value => {
          updateProperty(value as ModelInputFileAttachmentType);
        }}
        required={required}
      />
    </div>
  );
};

export default ModelInputFileAttachmentChoicesBuilder;
